import { useDebounce } from '@/hooks/useDebounce';
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/components/ui/use-toast";
import { useState, useEffect } from 'react';

export default function TaskSummary({ task, onTaskChange, isLoading }) {
    const [summary, setSummary] = useState(task?.summary || '');
    const debouncedSummary = useDebounce(summary, 1000);
    const { axiosInstance } = useAuth();
    const { toast } = useToast();

    useEffect(() => {
        if (debouncedSummary && task && debouncedSummary !== task.summary) {
            handleSummaryUpdate(debouncedSummary);
        }
    }, [debouncedSummary]);

    const handleSummaryUpdate = async (newSummary) => {
        try {
            await axiosInstance.patch(`/tasks/${task.organization.slug}/${task.key}`, { summary: newSummary });
            // Note: I don't think we need to update the task here, since the text is edited live in the UI
            toast({
                description: "Summary saved successfully"
            });
        } catch (error) {
            toast({
                description: "Failed to update summary",
                variant: "destructive"
            });
        }
    };

    const handleSummaryInput = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        } else {
            setSummary(e.target.innerText);
        }
    };

    return (
        <div className="max-w-3xl mx-auto w-full min-h-11">
            {isLoading ? (
                <div className="h-11 flex items-center justify-start">
                    <div className="h-8 bg-muted animate-pulse rounded-md w-2/3" />
                </div>
            ) : (
                <div
                    contentEditable
                    suppressContentEditableWarning
                    onInput={handleSummaryInput}
                    onKeyDown={handleSummaryInput}
                    className="text-2xl font-semibold focus:outline-none py-2 min-h-11"
                    dangerouslySetInnerHTML={{ __html: task?.summary }}
                />
            )}
        </div>
    );
}